import {
  getDashboardContextStyles,
  getDashboardFocusStyle
} from './moduleHierarchySelection';

/**
 * OL Feature 에 focus/context 스타일 적용
 *
 * @param {{ focus, contextString, contextArray, rowKind? }} highlight
 * @param {object} options
 * @param {typeof import('ol/style/Style').default} options.Style
 * @param {typeof import('ol/style/Stroke').default} options.Stroke
 * @param {typeof import('ol/style/Fill').default} options.Fill
 */
export function applyModuleHierarchyHighlightStyles(
  highlight,
  { Style, Stroke, Fill, focusRowKind, focusStyles, contextStyles } = {}
) {
  if (!Style || !Stroke || !Fill || !highlight) return [];

  const rowKind = focusRowKind ?? highlight.rowKind;
  const focusStyleConfig = getDashboardFocusStyle(rowKind, focusStyles);
  const ctxStyles = getDashboardContextStyles(contextStyles);
  const isModuleFocus =
    rowKind === 'panel' || rowKind === 'panel_single' || highlight.focusTier === 'module';
  const focusStrokeWidth = isModuleFocus ? 5 : 4;

  // zIndex: focus(module) > contextString > contextArray — 겹칠 때 선택 모듈이 항상 위
  const toStyle = (cfg, width, zIndex) =>
    new Style({
      stroke: new Stroke({
        color: cfg.stroke,
        width: width ?? cfg.width ?? cfg.strokeWidth ?? 3
      }),
      fill: new Fill({ color: cfg.fill }),
      zIndex
    });

  const styled = [];

  (highlight.focus || []).forEach(f => {
    f.setStyle(toStyle(focusStyleConfig, focusStrokeWidth, 30));
    styled.push(f);
  });
  (highlight.contextString || []).forEach(f => {
    f.setStyle(toStyle(ctxStyles.string, 2, 20));
    styled.push(f);
  });
  (highlight.contextArray || []).forEach(f => {
    f.setStyle(toStyle(ctxStyles.array, 2, 10));
    styled.push(f);
  });

  return styled;
}

/**
 * source에서 빠져도 Feature 객체에 남은 선택 스타일을 지운다.
 * (새로고침 후 이전 array가 선택된 채로 보이는 원인)
 */
export function clearModuleHierarchyHighlightStyles(features) {
  (features || []).forEach(f => {
    if (typeof f?.setStyle === 'function') {
      f.setStyle(null);
    }
  });
}
